import { gql, useQuery } from "@apollo/client";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Loading } from "../Loading";
import NotMatch from "../../Pages/NotMatch";

const Style = styled.div`
    display: flex;
    flex-wrap: wrap;
    /* flex-direction: column; */
    position: relative;
    padding: 1rem;
    gap: 1rem;
    justify-content: center;
    .user {
      text-decoration: none;
      color: inherit;
      min-width: 300px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem;
      border-radius: 0.5rem;
      border: 1px solid #aaaaaa;
      .image {
        width: 150px;
        aspect-ratio: 1;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }

`;
const UsersActive_Query = gql`
  query UsersActiveQuery{
    getUsersActive{
      _id
      FName
      LName
    }
  }
`
export default function Profiles({pageHeight, data, language}) {
    const users = useQuery(UsersActive_Query);
    if(users.loading){
        return (
            <div style={{marginTop: "120px"}}>
              <Loading/>
            </div>
        )
    }
    if(!users.data.getUsersActive.length){
        return (
            <NotMatch key={0}/>
        )
    }
    let dataUser = users.data.getUsersActive;
    return (
      <Style>
        {
          dataUser.map((v, i) => {
            return (
              <Link className="user" to={"/en/profile?USER="+ v._id} key={i}>
                <div className="name">
                  {v.FName} {v.LName} 
                </div>
                <div className="image">
                  <img src={"https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=https://farazandishan.com/en/profile?USER="+ v._id} alt={v.FName + " " + v.LName}/>
                </div>
              </Link>
            )
          })
        }
      </Style>
  );
}